<div id="delivery-dialog">
  <h2 *ngIf="!delivery" mat-dialog-title>Add Job</h2>
  <h2 *ngIf="delivery" mat-dialog-title>Edit Job</h2>
  <mat-dialog-content>
    <form [formGroup]="deliveryForm">
      <mat-horizontal-stepper [linear]="true" #matHorizontalStepper>
        <ng-template matStepperIcon="done">
          <mat-icon>done</mat-icon>
        </ng-template>
        <mat-step label="Items" #itemsStep>
          <p>Select the items that are on this job.</p>
          <table class="table">
            <thead>
              <tr>
                <th width="40">
                  <mat-checkbox (change)="toggleAllItems($event)" [(ngModel)]="selectAll" id="select-all-items"
                    [ngModelOptions]="{ standalone: true }"></mat-checkbox>
                </th>
                <th>Item</th>
              </tr>
            </thead>
            <tbody *ngIf="deliveryForm['controls'].items['controls'].length" formArrayName="items">
              <tr *ngFor="
                  let item of deliveryForm['controls'].items['controls'];
                  let i = index
                " [formGroupName]="i" [testId]="'delivery-item-' + i">
                <td width="40">
                  <mat-checkbox formControlName="deliver" value="true" class="delivery-items"
                    (change)="itemSelectionChange()"></mat-checkbox>
                </td>
                <td>{{ deliveryForm.value.items[i].description }}</td>
              </tr>
            </tbody>
          </table>
          <div class="flex flex-row justify-end items-center space-x-2"></div>
        </mat-step>

        <mat-step label="Details">
          <div class="flex flex-col">
            <mat-radio-group
              class="flex flex-col md:flex-row justify-start items-start md:items-center mb-3 md:space-x-5"
              formControlName="type">
              <p>Type:</p>
              <mat-radio-button value="delivery" id="delivery">Delivery
              </mat-radio-button>
              <mat-radio-button value="collection" id="collection">Collection
              </mat-radio-button>
              @if(!delivery){
              <mat-radio-button value="both" id="both">Delivery & Collection
              </mat-radio-button>
              }
            </mat-radio-group>

            <mat-radio-group
              class="flex flex-col md:flex-row justify-start items-start md:items-center mb-3 md:space-x-5"
              formControlName="external_fulfillment">
              <p>Fulfillment:</p>
              <mat-radio-button [value]="false">Internal</mat-radio-button>
              <mat-radio-button [value]="true">External</mat-radio-button>
            </mat-radio-group>

            @if (deliveryForm.value['external_fulfillment']) {
            <mat-form-field>
              <mat-label>Fulfillment provider</mat-label>
              <input matInput formControlName="fulfillment_provider" type="text" placeholder="Fulfillment provider"
                autocomplete="off" id="customer" />
            </mat-form-field>
            } @else {
            <mat-form-field>
              <mat-label>Assign to</mat-label>
              <mat-select formControlName="allocated_to">
                <mat-option *ngFor="let user of assignableUsers$ | async" [value]="user.id">{{ user.name }}</mat-option>
              </mat-select>
            </mat-form-field>
            }

            <div class="pt-2 w-full flex flex-col justify-start items-stretch">

              <mat-radio-group
                class="flex flex-col md:flex-row justify-start items-start md:items-center mb-3 md:space-x-5"
                [(ngModel)]="addressType" [ngModelOptions]="{ standalone: true }"
                (change)="setValidationBasedOnAddressType($event.value)">
                <p>Address:</p>
                <mat-radio-button value="search" id="search">Search
                </mat-radio-button>
                <mat-radio-button value="typed" id="typed">Type
                </mat-radio-button>
                <mat-radio-button value="previous" id="previous">Previous
                </mat-radio-button>
              </mat-radio-group>
              @if (addressType === 'previous') {
              <app-previous-delivery-select [customerId]="data.customer.id" [currency]="data.currency"
                [currencyRate]="data.currencyRate"
                (previousDeliverySelected)="selectPreviousDeliveryAddressAndPrice($event)"></app-previous-delivery-select>
              }
              @if (addressType === 'search') {
              <app-address-search-field formControlName="address"></app-address-search-field>
              }
              @if (addressType === 'typed') {
              <div class="flex flex-col justify-start items-stretch">
                <div class="flex flex-row justify-between items-center space-x-2">
                  <div class="flex flex-row justify-start items-center space-x-2">
                    <mat-checkbox [(ngModel)]="useCustomerAddress" (change)="customerAddressToggle($event)"
                      [ngModelOptions]="{ standalone: true }" id="use-customer-address"></mat-checkbox>
                    <p>Use Customer Address</p>
                  </div>
                </div>
                <mat-form-field>
                  <mat-label>Delivery Address</mat-label>
                  <textarea matInput placeholder="Delivery Address" formControlName="location"
                    [readonly]="useCustomerAddress" name="Delivery Address/Description" id="delivery-address"
                    matTextareaAutosize matAutosizeMinRows="5"></textarea>
                </mat-form-field>
                <mat-error *ngIf="deliveryForm.get('location').hasError('required')">
                  Delivery address is required
                </mat-error>
              </div>
              }
            </div>
            <app-delivery-estimate [destination]="deliveryForm.value['address']?.place_id" (estimateSelected)="
                deliveryForm.patchValue({ charge: $event / 100 })
              "></app-delivery-estimate>
            <mat-form-field>
              <mat-label>Charge</mat-label>
              <input matInput formControlName="charge" type="number" placeholder="Charge" autocomplete="off"
                id="charge" />
              <span matPrefix [appAddCurrencyPrefix]="data.currency"></span>
              <mat-error *ngIf="deliveryForm.get('charge').hasError('required')">Charge is required - enter 0 for no
                charge</mat-error>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Notes</mat-label>
              <textarea matInput formControlName="notes" placeholder="Notes" id="notes" matTextareaAutosize
                matAutosizeMinRows="2"></textarea>
            </mat-form-field>

            @if (deliveryForm.value['type'] === 'both') {
            <h3 class="text-2xl">Delivery</h3>
            }
            <div class="flex flex-col md:flex-row md:space-x-4">
              <mat-form-field class="basis-1/2">
                <input matInput formControlName="due_date" id="due-date" [matDatepicker]="picker" autocomplete="off"
                  placeholder="Date" />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error *ngIf="deliveryForm.get('due_date').hasError('required')">Date is required</mat-error>
              </mat-form-field>

              <mat-form-field class="basis-1/2">
                <mat-label>Time</mat-label>
                <input matInput name="due_time" formControlName="due_time"
                  (blur)="updateTimeEnteredManually('due_time', pickerA)" placeholder="Time" />
                <mat-error *ngIf="deliveryForm.get('due_time').hasError('invalidTime')">Invalid time value, please enter
                  in the format: HH:mm (24
                  hour)</mat-error>
                <mat-icon matSuffix (click)="pickerA.open()">access_time</mat-icon>
                <mat-error *ngIf="deliveryForm.get('due_time').hasError('required')">Time is required</mat-error>
              </mat-form-field>
              <ngx-mat-timepicker [format]="24" enableKeyboardInput dottedMinutesInGap
                (timeSet)="updateTime($event, 'due_time')" #pickerA></ngx-mat-timepicker>
            </div>

            @if (deliveryForm.value['type'] === 'both') {
            <h3 class="text-2xl">Collection</h3>
            <div class="flex flex-col md:flex-row md:space-x-4">
              <mat-form-field class="basis-1/2">
                <input matInput formControlName="second_due_date" id="second-due-date" [matDatepicker]="picker2"
                  autocomplete="off" placeholder="Date" />
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
                <mat-error *ngIf="deliveryForm.get('second_due_date').hasError('required')">Date is required</mat-error>
              </mat-form-field>

              <mat-form-field class="basis-1/2">
                <mat-label>Time</mat-label>
                <input matInput name="second_due_time" formControlName="second_due_time"
                  (blur)="updateTimeEnteredManually('second_due_time', pickerB)" placeholder="Time" />
                <mat-error *ngIf="deliveryForm.get('second_due_time').hasError('invalidTime')">Invalid time value,
                  please enter
                  in the format: HH:mm (24
                  hour)</mat-error>
                <mat-icon matSuffix (click)="pickerB.open()">access_time</mat-icon>
                <mat-error *ngIf="deliveryForm.get('second_due_time').hasError('required')">Time is required</mat-error>
              </mat-form-field>
              <ngx-mat-timepicker [format]="24" enableKeyboardInput dottedMinutesInGap
                (timeSet)="updateTime($event, 'second_due_time')" #pickerB></ngx-mat-timepicker>
            </div>
            }
          </div>
        </mat-step>
      </mat-horizontal-stepper>
    </form>
  </mat-dialog-content>

  <div class="flex flex-row justify-end items-center space-x-2" mat-dialog-actions align="end">
    <ng-container *ngIf="matHorizontalStepper.selectedIndex === 0; else saveOption">
      <button mat-button (click)="dialogRef.close()">Cancel</button>
      <button mat-button (click)="matHorizontalStepper.next()" [disabled]="!itemsStep.completed" type="button"
        id="next-button">
        Next
      </button>
    </ng-container>
    <ng-template #saveOption>
      <button mat-button type="button" (click)="dialogRef.close()">
        Cancel
      </button>
      <button mat-raised-button color="primary" (click)="submit()" id="save-button">
        Save
      </button>
    </ng-template>
  </div>
</div>